<template>
    <div class="accordion box" role="presentation" :style="customStyle">
        <AccordionItem @toggle="toggle"  @accordionAction="$emit('accordionAction')" @copyElement="$emit('copyElement')" @deleteElement="$emit('deleteElement',index)" v-for="(item,index) in content"
                       :multiple="multiple"
                       :dynamic-name="item.itemComponentName"
                       :dynamicProps="item.itemComponentProps"
                       :item="item"
                       :title="item.title"
                       :key="item.itemComponentName+'-'+index" :index="index"></AccordionItem>
    </div>
</template>

<script>
    import AccordionItem from "./AccordionItem";

    export default {
        name: "Accordion",
        components: {AccordionItem},
        props: {
            content: {
                type: Array,
                required: true
            },
            multiple: {
                type: Boolean,
                default: false
            },
            customStyle: String
        },
        data() {
            return {
                groupId: null
            }
        },
        mounted() {
            this.groupId = this.$el.id
        },
        methods:{
            toggle(json){
                this.$emit('toggle',json);
            }

        }
    }
</script>

<style lang="scss" scoped>

    .accordion {
        padding: 0;

        div:last-child .accordion-item-details {
            border-radius: 5px;
        }

        dd {
            margin-left: 0;
        }
    }

</style>